import { render, staticRenderFns } from "./LotsAdd.vue?vue&type=template&id=2cd3df82&scoped=true&"
import script from "./LotsAdd.vue?vue&type=script&lang=js&"
export * from "./LotsAdd.vue?vue&type=script&lang=js&"
import style0 from "./LotsAdd.vue?vue&type=style&index=0&id=2cd3df82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd3df82",
  null
  
)

component.options.__file = "LotsAdd.vue"
export default component.exports